<template>
  <div class="page">
<div class="div">
 <!-- <div class="header_top">

 </div>  -->
<div class="title_header">

  
<headerTitle  isChange @change="studentChange" @onRightbox="onRightbox" :studentStatusData="studentStatusData"/>
<van-skeleton title  :row="10" :loading="loading" style="background-color: #fff;">


<div class="card2 cardBox">
  <div style="display: flex;align-items: center;justify-content: space-between; font-size: 15px;font-weight: 500;margin-bottom: 20px;">
    <div style="color: #000;width: 40%;" class="dotted-div">今日总览</div>
  </div>
  <div class="card2_bottom">
  <div class="card2_leftbox">
    <div style="margin-bottom: 3px;">课间锻炼：
      <span style="color:rgb(46, 139, 211);font-size: 14px;" v-if="list&&list.length>0"><van-icon name="checked" />已参与</span> 
      <span style="color:red;font-size: 14px;" v-else><van-icon name="checked" />未参与</span> 
    </div>

    <div class="ranking-container">
    <!-- 班级排名 -->
    <div class="ranking-item">
      <div class="ranking-track">
          <div class="ranking-bar"  :style="{height:TopNewFitnessData.classTop==0?'0%': 100- +TopNewFitnessData.classTop +'%'}"></div>
      </div>
      <!--  -->
      <div class="ranking-number"><span style="font-size: 8px;">NO</span>.{{TopNewFitnessData.classTop}}</div>
    </div>

    <!-- 年级排名 -->
    <div class="ranking-item">
      <div class="ranking-track">
          <div class="ranking-bar" :style="{height:TopNewFitnessData.gradeTop==0?'0%':100- +TopNewFitnessData.gradeTop +'%'}"></div>
      </div>
      <div class="ranking-number"><span style="font-size: 8px;">NO</span>.{{TopNewFitnessData.gradeTop}}</div>
    </div>
  </div>
  
    <div class="ranking-container-bottom">
    <!-- 班级排名 -->
    <div class="ranking-item">
      <div class="ranking-text">班级排名
        <img src="@/assets/parentImg/up.png" alt="" width="10" v-if="+TopNewFitnessData.classTop > +TopNewFitnessData.otherClassTop">
        <!-- <span v-else-if="+TopNewFitnessData.classTop == +TopNewFitnessData.otherClassTop">--</span> -->
        <img src="@/assets/parentImg/down.png" alt="" width="10" v-else>
      </div>
      <!-- <div class="ranking-arrow ranking-arrow-up">↑</div> -->
    </div>

    <!-- 年级排名 -->
    <div class="ranking-item">
      <div class="ranking-text">年级排名
        <img src="@/assets/parentImg/up.png" alt="" width="10" v-if="+TopNewFitnessData.gradeTop > +TopNewFitnessData.otherGradeTop">
        <img src="@/assets/parentImg/down.png" alt="" width="10" v-else>
      </div>
      <!-- <div class="ranking-arrow ranking-arrow-down">↓</div> -->
    </div>
  </div>

  </div>



  <div class="card2_rightbox">
    <!-- <van-circle
    size="18vw"
    :layer-color="'rgb(235, 238, 244)'"
    :stroke-width="60"
    v-model="currentRate"
    :rate="rate"
    :color="{
          '0%': '#13c3ff',
          '100%': '#1956ca',
        }"
    text="渐变色"
/> -->

<componentProgress
 class='upgrade-progress'
    ref="progress"
      :isAnimation='options.isAnimation'
      :isRound='options.isRound'
      :width='options.width'
      :radius='options.radius'
      :progress='options.progressPro'
      :barColor='options.barColors'
      :duration='options.duration'
      :timeFunction='options.timeFunction'
      :backgroundColor='options.backgroundColor'
      :title='options.title'
      :number='options.number'
/>
<!-- <div class="progress-circle">
  <svg>
    <circle stroke="var(--inactive-color)" style="stroke-width: 1vw;"/>
    <circle stroke="var(--color)"
            class="progress-value"
            style="stroke-dasharray: calc(2 * 3.1415 * var(--r) * (var(--percent) / 100)), 1000"
            />
  </svg>
</div> -->

  </div>
  </div>


</div> 

<!-- <div class="card1 cardBox">
  <div class="card-eachart " ref="card1"></div>
</div>  -->
<!-- <div class="card2 cardBox">
  <div style="display: flex;align-items: center;justify-content: space-between; font-size: 16px;font-weight: 700;margin-bottom: 22px;">
    


    <div style="color: #000;width: 40%;">今日运动概览</div>
    <div style="width: 30%;">
      <van-tabs >
        <van-tab title="体测"></van-tab>
        <van-tab title="体锻"></van-tab>
      </van-tabs>
    </div>
    
    
    <van-popover v-model="showPopover"  trigger="click" :actions="yearList" @select="onSelectPopover">
                  <template #reference>
                    <div class="year_box" >
                    <div>{{ termName }}</div>
                    <div><van-icon name="arrow" :color="active == 0 ? '#000' : '#aaa'" /></div>
                  </div>
                  </template>
        </van-popover>


    
  </div>
  <div class="card2_textbox">

  <div><span style="color: #aaa;font-size: 12px;">课间锻炼:</span><span style="color: blue;"> 已完成·</span></div>
  <div><span style="color: #aaa;font-size: 12px;">动作总次数:</span>38 次，比同龄人略高</div>
  <div><span style="color: #aaa;font-size: 12px;">班级排名:</span>第5名</div>
  <div><span style="color: #aaa;font-size: 12px;">全校排名:</span>第 25 名</div>
  </div>
</div>  -->

</van-skeleton>
</div>
<div class="schedule_box">
    <!-- <div style="display: flex;align-items: center;justify-content: space-between; font-size: 15px;font-weight: 500;margin-bottom: 20px;">
    <div style="color: #000;width: 40%;" class="dotted-div">今日推荐任务</div>
  </div> -->
  <div class="schedule_list">

    <div class="schedule_item" v-for="(item, index) in BodyProjectRelList">
      <div style="width: 35%;">
        <img :src="item.image" width="100%" height="100%"  alt="">
      </div>
      <div  style="width: 57%;margin-left: 3%;display: flex;flex-direction: column;justify-content: space-between;">
         <div  class="schedule_item_title" style="text-align: right;">{{ item.projectName||'' }}</div>
          <div style="" class="schedule_item_content"> 
            <!-- style="color: #4373CD;" -->
           <span  :style="{color: +item.score - +item.nowScore >0?'#4373CD':'green' }">{{ +item.nowScore }}</span>
           <span style="color: #ADADAD;">/{{ +item.score }}</span>
          </div>

          <div  class="schedule_item_bottom"  style="text-align: right;"  v-if="+item.score - +item.nowScore>0">
            还差{{ +item.score - +item.nowScore}} {{item.projectUnit}}完成!
          </div>
          <div v-else style="text-align: right;font-size: 12px;color:green;">
              已完成
              <van-icon name="checked" color="green" size="14px"/>
          </div>
      </div>
     
    </div>


  </div>

</div>


<div class="classroom_box">
    <div style="display: flex;align-items: center;justify-content: space-between; font-size: 15px;font-weight: 500;margin-bottom: 10px;padding: 0 10px;">
    <div style="color: #000;width: 40%;" class="dotted-div">智选课堂</div>
    <div style="width: 20%;" class="allVideo-div" @click="ongoAllVideo">查看全部 ></div>

  </div>
  <div class="schedule_list">

    <div class="schedule_item" v-for="(item, index) in classroomvideoList" :key="index">

      <div style="width: 45%;border-radius: 10px;height: 100%;" >

        <img :src="item.image"
        style="border-radius: 10px;object-fit: cover;"
          width="100%" height="100%" alt="">
        <!-- <van-image
          style="border-radius: 10px;"
          width="100%"
          height="100%"
          fit="cover"
          :src="item.image"
        /> -->
      
      </div>
      <div style="width: 2%;"></div>
      <div style="width: 52%;" @click="toVideoDetail(item)">
        <div class="schedule_item_title">{{ item.name||'' }}</div>
        <div class="schedule_item_content">{{ item.name||'' }}</div>
        <div class="schedule_item_bottom">
          
        <div class="schedule_item_bottom_left"> 
          <img src="./image/videoicon.png" alt="" width="18px">
           &nbsp; 全身运动</div>
        <div class="schedule_item_btn">播放</div>

        </div>

      </div>
    </div>


  </div>

</div>




<div class="menu">


<!-- <div class="menu_row">
   <div style="width:40%" class="menu_li" v-for="value in menuList" :key="value.id" @click="goPage(value)">
      <img :src="value.url" alt=""  height="40vw" style="margin:8px;">
      <div style="text-align:center;"> {{value.name}}</div>
  </div>
</div> -->
<section class="appeal-list-warp">
    <div class="appeal-list-title">
      <div style="font-size: 16px;font-weight: 500;" class="dotted-div">今日运动记录</div>
      <div @click="getAllIntegral" style="color: rgb(46, 139, 211);">全部领取 <van-icon name="arrow" /></div>
    </div>
      <div v-if="list.length">
  <van-skeleton title  :loading="loading" style="background-color: #fff;">

        <div class="item" v-for="(item, index) of list" :key="index" >

          <div class="item-li">
            <div class="item-li-left">
              <div class="timeline-line"></div>
              <!-- <div style="font-size:16px;font-weight:500;">{{ formatDate(item.testTime, 'DD') }}日</div>
              <div style="color:#B8B8B8;">{{ formatDate(item.testTime, 'MM') }}月</div> -->
              <!-- <div style="color:#B8B8B8;font-size: 12px;">{{ formatDate(item.testTime, 'MM-DD') }}</div> -->
              <div style="color:#2e8bd3;font-size:15px;font-weight:600;line-height: 80px;">{{ formatDate(item.testTime, 'HH:mm') }}</div>
            </div>
            <div style="width: 2%;"></div>
            <!-- props.active ? require('@/assets/icon/运动之星选中.png') :  require('@/assets/icon/运动之星.png') -->
            <div  class="item-li-right"
            :class="['item-li-right', index === 0 ? 'item-li-righta' : 'item-li-rightb']"
            >
        
            
              <div>
              <van-row>
                  <van-col span="18">
                    <span >{{item.projectName}}</span>
                  </van-col>
                  <van-col span="6">
                        <!-- <div class="item-li-right-goal">
              +15 <span style="font-size: 12px;font-weight: 400;">分</span>
            </div> -->
                    <!-- <span class="right" :class="`bg${item.status}`">{{ SetValue[item.status] }}</span> -->
                  </van-col>
              </van-row>
            </div>

            <!-- <div >
                <div style="font-size:12px;" v-if="+item.status == 0">
                    <van-row>
                  <van-col span="18">
                  </van-col>
                  <van-col span="6">
                    {{SetwarnType[item.warnType]}}
                  </van-col>
              </van-row>
                </div>
            </div> -->

            <div>
              <van-row class="mileagebox">

                
                <van-col span="11" >
                  <div  class="mileageStyle">
                    <span style="letter-spacing: -1px;" v-html="formatScore(item.score)"></span>
                    <span style="font-size: 12px;font-weight: 500;margin-left: 1px;">{{ item.projectUnit ||'--'}} </span> 
                  </div>
                </van-col>
                <van-col span="8" >
                  <div  class="mileageStyle" :style="{color: colors[item.level]}">
                    <span style="letter-spacing: -1px;">{{item.fraction||0}}</span>
                    <span style="font-size: 12px;font-weight: 500;margin-left: 1px;">{{ item.level }} </span> 
                  </div>
                </van-col>

                
                  <van-col span="5">


                      <div class="getIntegralBox" @click="getIntegral(item)" v-if="+item.sportsPointsType==0">
                          <div style="font-size: 20px;font-family: DINPro-Bold;">+15</div>
                          <div>领取积分</div>
                      </div>
                      <!-- sportsPointsType 0 未领取 1 已领取 -->
                       <div class="getIntegralBoxV2"  v-if="+item.sportsPointsType==1">
                          <div>已领取</div>
                      </div>
                    


                    <!-- <van-icon name="underway" /> -->
                    <span  >
                      <!-- {{ formatDate(item.testTime, 'hh:mm:ss') }} -->
                    </span>
                    <!-- <span style="color:#000;" v-else>- -</span> -->
                  </van-col>
                 
              </van-row>
            </div>
            </div>
            <div style="width: 3%;"></div>
          </div>
        </div>
</van-skeleton>

      </div>
      <van-empty v-else description="未查询到成绩数据" image-size="100" />
    </section>

<!-- <div class="menu_down">
    <div class="center fitnessBox" @click="onReport()">
    </div>
    <div class="center trainingBox"  @click="onbodyReport()">
    </div>
</div> -->


</div>


</div>
    <VDialog ref="VDialog" :objData="objData" />
    <!-- 内容区域 -->
    <main class="content-container">
      <router-view />
    </main>
<!-- <van-tabbar v-model="active" fixed>
  <van-tabbar-item icon="home-o">首页</van-tabbar-item>
  <van-tabbar-item icon="search" dot>运动之星</van-tabbar-item>
  <van-tabbar-item icon="friends-o" info="5">积分商城</van-tabbar-item>
  <van-tabbar-item icon="setting-o" info="20">个人中心</van-tabbar-item>
</van-tabbar> -->
  </div>
</template>

<script>
import {insertBaseSystemAccountWx,listRotationChart} from '@/api/common'
// import headerTitle from "./module/headerTitle.vue";
import VDialog from "@/components/VDialog";
import componentProgress from "@/components/componentProgress";
import headerTitle from "@/components/indexStudentTitleCard.vue";
import moment from 'moment';
import { getAllTestBySnCode} from "@/api/integralShop.js";
import * as echarts from 'echarts'
import { getEduYearList} from "@/api/resultReporting.js";
import { getStudentStatus,selectSportsPoints,saveSportsPoints,selectStudentActivityList,
  selectAllScoreNewFitness,selectDayTopNewFitness,selectBodyProjectRel} from "@/api/parentHomePage.js";
// import { getEduYearList} from "@/api/resultReporting.js";

export default {
  components: {
    headerTitle,
    VDialog,
    componentProgress
  },
  data() {
    return {
      studentStatusData:{
          faceStatus:0, //(0,无人脸,1,有人脸)
          homeStatus:0,   //(00,无作业任务,1,已提交,2,未提交)
          totalPoints:0
      },
      scheduleList:[
        // {name:'跳绳',value:'200',image:require('./image/tiaosheng.png')},
        {name:'排球颠球',value:'50',image:require('./image/paiqiu.png')},
        {name:'篮球拍球',value:'120',image:require('./image/lanqiu.png')},
      ],
      classroomvideoList:[




        // {name:'肺活量讲解',number:'10',remark:"备注说明", image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/肺活量讲解.mp4"},
        // {name:'立定跳远讲解',number:'10',remark:"备注说明", image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/立定跳远讲解.mp4"},
        // {name:'实心球动作示范',number:'10',remark:"备注说明", image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/实心球动作示范.mp4"},
        // {name:'实心球讲解',number:'10',remark:"备注说明", image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/实心球讲解.mp4"},
        {name:'跳绳运动讲解',number:'10',remark:"备注说明", image:require('./image/跳绳视频.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/跳绳运动讲解.mp4"},
        // {name:'跳绳运动示范跟练',number:'10',remark:"备注说明", image:require('./image/跳绳视频.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/跳绳运动示范跟练.mp4"},
        // {name:'仰卧起坐讲解',number:'10',remark:"备注说明", image:require('./image/仰卧起坐视频.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/仰卧起坐讲解.mp4"},
        // {name:'仰卧起坐示范跟练',number:'10',remark:"备注说明", image:require('./image/仰卧起坐视频.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/仰卧起坐示范跟练.mp4"},
        // {name:'引体向上动作示范',number:'10',remark:"备注说明", image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/引体向上动作示范.mp4"},
        // {name:'引体向上讲解',number:'10',remark:"备注说明", image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/引体向上讲解.mp4"},
        // {name:'坐位体前屈动作示范',number:'10',remark:"备注说明", image:require('./image/坐位体前屈视频.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/坐位体前屈动作示范.mp4"},
        {name:'坐位体前屈讲解',number:'10',remark:"备注说明", image:require('./image/坐位体前屈视频.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/坐位体前屈讲解.mp4"},
        // {name:'立走跳远动作示范',number:'10',remark:"备注说明", image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/立走跳远动作示范.mp4"},



        // {name:'卷腹跳',number:'50',remark:"备注说明", image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/卷腹跳.mp4"},
        // {name:'泡沫轴大腿前侧滚动右',remark:"备注说明", number:'50',image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/泡沫轴大腿前侧滚动右.mp4"},
        // {name:'泡沫轴大腿前侧滚动左',remark:"备注说明", number:'50',image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/泡沫轴大腿前侧滚动左.mp4"},
        // {name:'右脚单脚支撑摆臂',number:'50',image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/右脚单脚支撑摆臂.mp4"},
        // {name:'右腿单腿臀桥',number:'50',image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/右腿单腿臀桥.mp4"},
        // {name:'阻力带踮脚跳',number:'50',image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/阻力带踮脚跳.mp4"},
        // {name:'阻力带深蹲',number:'50',image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/阻力带深蹲.mp4"},
        // {name:'阻力带下拉',number:'50',image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/阻力带下拉.mp4"},
        // {name:'阻力带旋转',number:'50',image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/阻力带旋转.mp4"},
        // {name:'阻力带硬拉',number:'50',image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/阻力带硬拉.mp4"},
        // {name:'阻力带右腿拉伸',number:'50',image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/阻力带右腿拉伸.mp4"},
        // {name:'阻力带左腿拉伸',number:'50',image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/阻力带左腿拉伸.mp4"},
        // {name:'左脚单脚支撑摆臂',number:'50',image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/左脚单脚支撑摆臂.mp4"},
        // {name:'左腿单腿臀桥',number:'50',image:require('./image/paiqiu.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/左腿单腿臀桥.mp4"},

      ],
     options: {
        width:110, // 最大环宽度  直径
        radius: 10, //  环宽
        progressPro: 0, // 进度百分数

        barColors: { // 进度渐变色
          barColorStart: '#13c3ff',
          barColorEnd: '#1956ca'
        },
        duration: 1000, // 动画时长
        title: '我的积分',
        number: 0,
        backgroundColor: '#DCDADD', // 进度底色
        // 动画类型
        timeFunction: 'cubic-bezier(0.99, 0.01, 0.22, 0.94)',
        // 是否动画效果
        isAnimation: true,
        // 是否圆形描边
        isRound: true
      },
      loading:false,
      active:'',
     countAll:undefined,
     objData: {
        checked: false,
        num: 3,
        showDialog: false,
      },
      SetValue:{
      0: '不合格',
      1: '合格',
      2: '申诉合格',
      3: '补录合格',
      },
      SetwarnType:{
       1: '步数异常',
      2: '人脸异常',
      3: '拟合度异常',
      },
      colors:{
        '不及格':'#f16114',
        '及格':'#f3a919',
        '良好':'#1ea5eb',
        '优秀':'#0eb56c',
      },
      termCode:'',
      termName:'',
      yearList:[],
      showPopover:false,
      list:[
      ],
     swiperList: [{
      id: 0,
      type: 'image',
      url: require("./image/zhinan.png"),
      skipurl:'',
    }, 
    // {
    //   id: 2,
    //     type: 'image',
    //   url: require("./image/jiqiao.png"),
    //   skipurl:'https://mp.weixin.qq.com/s/lTKf3CvYa_-ROOVUEU3Cew',
    // }
    ],

 
menuList:[
  //  {
  //     id: 1,
  //     name:'学生绑定',
  //     url: require("./image/个人中心.png"),
  //   },
  //   {
  //     id: 0,
  //     name:'测训准考证',
  //     url: require("./image/制证.png"),
  //   }, 
  //   {
  //     id: 2,
  //     name:'家庭作业',
  //     url: require("./image/作业.png"),
  //   },
  
  //     {
  //     id: 4,
  //     name:'阳光跑',
  //     url: require("./image/阳光跑.png"),
  //   }, 
    {
      id: 5,
      name:'健康信息申报',
      url: require("./image/绑定.png"),
    },
    //  {
    //   id: 3,
    //   name:'通讯录',
    //   url: require("./image/通讯录@2x.png"),
    // }, 
    //  {
    //    id: 6,
    //    name:'积分商城',
    //    url: require("./image/商城.png"),
    //  }, 
     {
       id: 7,
       name:'运动分析',
       url: require("./image/分析.png"),
     }, 
    //  {
    //    id: 8,
    //    name:'运动之星',
    //    url: require("./image/记录.png"),
    //  }
],


    studentTitleInfo:{},
    TopNewFitnessData:{},
    BodyProjectRelList:[],
    }
  },
  computed: {

  },
  created() {
  },
  async mounted () {
    // await this.getEduYearList()
    this.studentTitleInfo = sessionStorage.getItem('studentTitleCard')?JSON.parse(sessionStorage.getItem('studentTitleCard')):{}
    this.init()
    // this.getcard1()
    if (this.studentTitleInfo.schoolCode=="LMWZ") {
      
    }

  },
  methods: {
    ongoAllVideo(){
      this.$router.push({
        path: '/videoMgt',
      })
    },
    toVideoDetail(item){
      this.$router.push({
        path: '/videoMgt',
        query: {
          name: item.name
        }
      })
    },
    getLevelColor(index) {
      const colors = ['#666', '#4CAF50', '#2196F3', '#9C27B0'];
      return colors[index];
    },
       // 查询学年
//  async getEduYearList(){
//  await getEduYearList({
//             snCode:this.data.snCode,
//             schoolCode:this.data.schoolCode,
//           }).then(res=>{  
//             res.data.data?.forEach(el=>{
//                   el.text = el.name
//               if(+el.isActive==1){
//                   this.data.termCode = el.code
//                   this.data.termName = el.name
//               }
//             })
//             this.yearList = res.data.data
//           })
//  },
      formatScore(score) {
      // 如果 score 是数字类型，格式化它为小数部分字体更小
      if (score==undefined||!score||score==''||score==null) {
        return '--'
      }
        // const scoreStr = score.toFixed(2);  // 保留两位小数
        const [integerPart, decimalPart] = score.split('.');
        
        if (decimalPart&&decimalPart.length>0) {
        return `${integerPart}<span style="font-size: 0.8em;">.${decimalPart}</span>`;
        }else{
      return score;  // 如果不是数字，直接返回原始值

        }
    },
  
       // 查询学年
 async getEduYearList(){
  
 await getEduYearList({
            snCode:this.studentTitleInfo.snCode,
            schoolCode:this.studentTitleInfo.schoolCode,
          }).then(res=>{  
            res.data.data?.forEach(el=>{
                  el.text = el.name
              if(+el.isActive==1){
                  this.termCode = el.code
                  this.termName = el.name
              }
            })
            this.yearList = res.data.data
          })
 },
    // 切换学年
    onSelectPopover(action){
         this.termCode = action.code
         this.termName = action.name
      },
    getcard1 (legend, indicator, series) {
      const myChart = echarts.init(this.$refs.card1)
      const option = {
  color: ['#FF0087',],
  title: {
    text: '运动趋势',
    fontSize:6,
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#6a7985'
      }
    }
  },
  legend: {
    data: ['运动频率']
  },
 
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  xAxis: [
    {
      type: 'category',
      boundaryGap: false,
      data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
    }
  ],
  yAxis: [
    {
      type: 'value'
    }
  ],
  series: [
    {
      name: '频率',
      type: 'line',
      stack: 'Total',
      smooth: true,
      lineStyle: {
        width: 0
      },
      showSymbol: false,
      label: {
        show: true,
        position: 'top'
      },
      areaStyle: {
        opacity: 0.8,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#00c0fa'
          },
          {
            offset: 1,
            color: '#015eea'
          }
        ])
      },
      emphasis: {
        focus: 'series'
      },
      data: [220, 302, 181, 234, 210, 0, 0]
    }
  ]
};

      if (option && typeof option === 'object') {
        myChart.setOption(option)
      }

      window.addEventListener('resize', myChart.resize)
    },

    getAllTestBySnCode(){
      this.loading =true
          getAllTestBySnCode({
              snCode:this.studentTitleInfo.snCode,
              schoolCode:this.studentTitleInfo.schoolCode,
            }).then(res=>{
        this.loading =false
           
              // this.list = (res.data.body || []).slice(0, 100);
            })
      },
     formatDate(datestr = new Date(), formart = 'YYYY年MM月DD日') {
    return moment(datestr).format(formart);
},
   async studentChange(val){
    this.studentTitleInfo =val
   await this.getEduYearList()

    // this.getAllTestBySnCode()
    this.getStudentStatus()
    this.selectAllScoreNewFitness()
    this.selectSportsPoints()
    this.selectStudentActivityList()
    this.selectDayTopNewFitness()
    this.selectBodyProjectRel()
  },
  onRightbox(){
     let data = JSON.stringify({...this.studentTitleInfo,totalPoints:this.studentStatusData.totalPoints })
      this.$router.push({path:'fitnessReportV2',query:{data:data}})
  },
  onReport(){
      let data = JSON.stringify({...this.studentTitleInfo, })
      this.$router.push({path:'fitnessReport',query:{data:data}})
  },
  onbodyReport(){
      let data = JSON.stringify({...this.studentTitleInfo,})
      this.$router.push({path:'bodyForging',query:{data:data}})
  },
    init(){
       const isChecked = localStorage.getItem("isChecked") || false;
        if (!isChecked) {
          this.objData.showDialog = true;
          this.$refs.VDialog.countdown();
        }
    // this.getAllTestBySnCode()



    },
    selectDayTopNewFitness(){
      let day = moment(new Date()).format('yyyy-MM-DD')
      let otherDay = moment().subtract(1, 'day').format('YYYY-MM-DD')

      selectDayTopNewFitness({
        day:day,
        otherDay:otherDay,
        termCode:this.termCode,
        snCode:this.studentTitleInfo.snCode,
        schoolCode:this.studentTitleInfo.schoolCode,
      }).then(res=>{
        console.log(res);
        this.TopNewFitnessData = res.data.body
        
      })
    },

    selectBodyProjectRel(){

      selectBodyProjectRel({
        termCode:this.termCode,
        snCode:this.studentTitleInfo.snCode,
        schoolCode:this.studentTitleInfo.schoolCode,
        studentName:this.studentTitleInfo.studentName,
        
      }).then(res=>{
        console.log(res);
        this.BodyProjectRelList = res.data.body
        if (this.BodyProjectRelList.length>0) {
          this.BodyProjectRelList.forEach(el=>{



            switch (el.projectCode) {
            case 'DeepSquat':el.image = require('./image/huoli15.png');break
            case 'RopeSkipping':el.image = require('./image/huoli15.png');break
            case 'SquatJump':el.image = require('./image/huoli15.png');break
            case 'JumpingJack':el.image = require('./image/huoli15.png');break
            case 'LeftRightJump':el.image = require('./image/huoli15.png');break
            case 'LanQiu':el.image = require('./image/lanqiu.png');break
            case 'PaiQiu':el.image = require('./image/paiqiu.png');break
            case 'RopeSkippingPro':el.image = require('./image/tiaosheng.png');break
            case 'Jump':el.image = require('./image/lidingtiaoyuan.png');break


            // case 'HeightWeight':el.image = require('./image/huoli15.png');break
            // case 'TZ':el.image = require('./image/huoli15.png');break
            // case 'Jump':el.image = require('./image/huoli15.png');break
            // case 'PullUp':el.image = require('./image/huoli15.png');break
            // case 'SitUp':el.image = require('./image/huoli15.png');break
            // case 'SitAndReach':el.image = require('./image/huoli15.png');break
            // case 'TricepsDip':el.image = require('./image/huoli15.png');break
            // case 'LengthwaysJump':el.image = require('./image/huoli15.png');break

            default:el.image = require('./image/huoli15.png')
              break;
          }

        

          })
        }
        
      })
    },

    getStudentStatus(){
      getStudentStatus({
        termCode:this.termCode,
        snCode:this.studentTitleInfo.snCode,
        schoolCode:this.studentTitleInfo.schoolCode,
        
      }).then(res=>{
        this.$set(this.studentStatusData,"faceStatus",res.data.body.faceStatus)
        this.$set(this.studentStatusData,"homeStatus",res.data.body.homeStatus)
        
      })
    },

    selectAllScoreNewFitness(){
      selectAllScoreNewFitness({
        termCode:this.termCode,
        snCode:this.studentTitleInfo.snCode,
        schoolCode:this.studentTitleInfo.schoolCode,
      }).then(res=>{
        console.log(res);
        
        this.$set(this.studentStatusData,"totalPoints",res.data.body.fractionDouble)
        this.$set(this.studentStatusData,"level",res.data.body.level)
      })
    },
    selectSportsPoints(){
      selectSportsPoints({
        termCode:this.termCode,
        snCode:this.studentTitleInfo.snCode,
        schoolCode:this.studentTitleInfo.schoolCode,
      }).then(res=>{
        // this.list = res.data.body||[]
        this.options.number = +res.data.weightScore||0
        this.options.progressPro = res.data.weightScore/500 * 100||0
        
        console.log('selectSportsPoints',res);
        
      })
    },

      getIntegral(item){
        this.saveSportsPoints(item.fitnessScantronId)
      },
      getAllIntegral(){
      // if (this.options.progressPro==100) {
      //   return
      // }
      if (this.list.length==0) {
        this.$toast({ icon: "error", message: "今日记录为空！" });
        return
      }
      // this.$set(this.options,'progressPro',this.options.progressPro+10)
        this.saveSportsPoints('all')
    },
    // ,,,fitnessScantronId(成绩的测试id,如果是全部领取,传all),sportsPoints(运动积分,先默认传10或者15分)
    saveSportsPoints(val){
      saveSportsPoints({
        termCode:this.termCode,
        schoolCode:this.studentTitleInfo.schoolCode,
        snCode:this.studentTitleInfo.snCode,
        studentName:this.studentTitleInfo.studentName,
        fitnessScantronId:val,
        sportsPoints:15,
      }).then(res=>{
        console.log('saveSportsPoints',res);
        this.$toast({ icon: "success", message: "操作成功！" });
        // 更新列表
        this.selectStudentActivityList()
        this.selectSportsPoints()

        
      })
    },
    selectStudentActivityList(){
      selectStudentActivityList({
        termCode:this.termCode,
        snCode:this.studentTitleInfo.snCode,
        schoolCode:this.studentTitleInfo.schoolCode,
        day:moment(new Date()).format('yyyy-MM-DD'),
      }).then(res=>{
        this.list = res.data.body||[]

        console.log('selectStudentActivityList',res);
        
      })
    },
      goswiper(val){
    // this.$router.push({path:url})
      },
goPage(val){
let url = ''
if (val.name=='学生绑定') {
 url = '/studentBind'
}
else if (val.name=='测训准考证') {
  url = '/admissionTicket'
 }else if (val.name=='家庭作业') {
  url = '/homework'
 }else if (val.name=='健康信息申报') {
  url = '/surveyMgt'
 }else if (val.name=='阳光跑') {
  url = '/sunrunScore'
 }else if (val.name=='积分商城') {
  url = '/integralShop'
 }else if (val.name=='运动分析') {
  url = '/fitnessReportV2'
 }

 
 
if (url!=='') {
    this.$router.push({path:url})
}else  {
  this.$toast({ icon: "error", message: "暂未开放，敬请期待！！" });
}
},

  }
};
</script>
<style lang="less" scoped>
@header-footer--line-height: 40px;
@font-face {
    font-family: DINPro-Bold;
   src: url(../../assets/font/DINPro-Bold.otf);
}
@font-face {
    font-family: DINPro-Medium;
   src: url(../../assets/font/DINPro-Medium.otf);
}

@font-face {
    font-family: DINPro-Regular;
   src: url(../../assets/font/DINPro-Regular.otf);
}
@font-face {
    font-family: DINPro-BlackItalic;
   src: url(../../assets/font/DIN-BlackItalic.otf);
}
.dotted-div {
  position: relative;
  padding-left: 15px; /* 为圆点留出空间 */
}
.dotted-div::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 6px;
  background-color: #09c1f9;
  border-radius: 50%; /* 关键：创建圆形 */
}
.allVideo-div{
  font-size: 12px;
  color: rgb(46, 139, 211);
}
.page{
  // background: #fcfafa2a;
  height: 100%;
  overflow: scroll;
  padding: 4vw;
  font-family: DINPro-Medium;


}
.header_top{
  background-image: url('../../assets/background/首页top.png');
	background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  // margin: 0 10px;
  background-size: cover;
  height: 200px;
  // border-radius: 0 0 10px 10px;
}
 .title_header{
  // height: 100px;
  
  // background-color: #fff;
  .cardBox{
  background-color: #fff;
  height: 15em;
  // margin: 10px ;
  padding: 6px;
  // border-radius: 10px;
  // box-shadow: 0px 1px 6px 0px #eef1fc;
}
.card-eachart{
  width: 100%;
  height: 15em;
}
 .card1{
  font-size: 12px;
  font-weight: 600;
  height: 15em;
}
.year_box{
  display: flex;
  justify-content: space-around;
  border: 1px solid #aaa;
  height: 20px;
  line-height: 20px;
  width: 80px;
  border-radius: 6px;
  text-align: right;
  font-size: 14px;
  color: #aaa;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  


}
.card2_textbox{
  // border-left: 3px solid #10afee;
  // border-radius: 10px;
  line-height: 28px;
  font-size: 14px;
}
 .card2{
  margin-top: 2vw;
  height: 12em;
  border-radius: 15px;
  padding: 4vw;
}
}
.card2_bottom{
  display: flex;
  justify-content: space-between;

  height: calc(100% - 40px);
}
.card2_leftbox{
  width: 55%;
  height: 100%;
  font-size: 12px;
  /* 样式容器 */
.ranking-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  height: calc(100% - 60px);
}
.ranking-container-bottom{
  border-top: 3px solid rgb(235, 238, 244);
  display: flex;
  justify-content: space-between;
}
.ranking-item {
  display: flex;
  // flex-direction: column;
  align-items: flex-end;
  text-align: center;
  height: 100%;
}
.ranking-track {
  position: relative;
  width: 10px;
  height: 100%;
  border-radius: 5px 5px 0 0;
  background-color: rgb(235, 238, 244);
  box-shadow: inset 0.052px 3px 7px 0px rgba(24, 88, 204, 0.58);
}

.ranking-bar {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 10px;
  border-radius: 5px 5px 0 0;
  background-image: -moz-linear-gradient( 0deg, rgb(25,88,203) 0%, rgb(20,191,253) 100%);
  background-image: -webkit-linear-gradient( 0deg, rgb(25,88,203) 0%, rgb(20,191,253) 100%);
  background-image: -ms-linear-gradient( 0deg, rgb(25,88,203) 0%, rgb(20,191,253) 100%);
}

.ranking-text {
  margin-top: 10px;
  font-size: 12px;
  font-weight: 500;
  color: #000;
}

.ranking-arrow {
  margin-top: 5px;
  font-size: 18px;
}

.ranking-arrow-up {
  color: green;
}

.ranking-arrow-down {
  color: red;
}

/* 文字和排名显示 */
.ranking-number {
  font-size: 12px;
  color: rgb(46, 139, 211);
  font-weight: 500;
  margin-left: 2px;
}

}
.card2_rightbox{
  width: 35%;
  height: 100%;



  .progress-circle {
  --percent: 20;  /* 百分数 */
  --size: 25vw;  /* 尺寸大小 */
  --border-width: 2vw;  /* 环宽（粗细） */
  // --color: linear-gradient(45deg, #13c3ff, #1956ca);  /* 主色 */
  --color: #1956ca;  /* 主色 */
  --inactive-color: rgb(235, 238, 244);  /* 辅助色 */
  
  position: relative;
  width: var(--size);
  height: var(--size);
  border-radius: 50%;
}


/* 百分数文本 */
.progress-circle::before {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  counter-reset: progress var(--percent);
  content: counter(progress);
  white-space: nowrap;
  font-size: 20px;
  color: rgb(46, 139, 211);
  font-weight: bold;
  line-height: 1.2;
}

/* SVG 容器 */
.progress-circle > svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

/* 进度条圆环 */
.progress-circle circle {
  --r: calc((var(--size) - var(--border-width)) / 2);
  cx: calc(var(--size) / 2);
  cy: calc(var(--size) / 2);
  r: var(--r);
  fill: none;
  stroke-width: var(--border-width);
  stroke-linecap: round;
  transition: stroke-dasharray .4s linear, stroke .3s;
}
/* 优化：进度为0时隐藏进度条 */
.progress-value {opacity: var(--percent);}
  
}

.title_image{
  width: 100%;
  height: 400rpx;
  position:fixed;
  z-index: -999;
}
  .fitnessBox{
    background-image: url('../../assets/image/体测报告btn.jpg');
	  background-repeat: no-repeat;
	background-size: cover;
  }
  .trainingBox{
    background-image: url('../../assets/image/锻炼报告btn.jpg');
	  background-repeat: no-repeat;
	background-size: cover;
  }
  .schedule_box{
    // height: 10em;
    width: 100%;
    // padding: 4vw;
    // background-color: #fff;
    // border-radius: 15px;
    // min-height: 60px;
    // height: 200px;
    // margin: 12px 0;
    
    .schedule_list{
         display: flex;
        flex-direction: row;
        flex-wrap: nowrap; /* 确保子项不换行 */
//flex-wrap: wrap;
justify-content: space-between;
        width: 100%;
        height: calc(100% - 40px);
        overflow-x: auto; /* 启用水平滚动 */
        scrollbar-width: thin; /* 可选：优化滚动条样式 */

      /* 隐藏滚动条但保留功能 (可选) */
    &::-webkit-scrollbar {
      display: none;
    }
    
    .schedule_item {
      height: calc(100% - 4vw);
      width: 50%;
      width: 44%;
      // margin: 10px 0;
      margin-top: 14px;
      margin-right: 10px;
      // min-width: 150px; /* 使用 min-width 而非固定宽度，确保有足够空间显示内容 */
      // margin-right: 1%; /* 添加间距 */
      flex-shrink: 0; /* 防止子项被压缩 */
      display: flex;
      background-color: #fff;
      border-radius: 15px;
      padding: 2vw;

      .schedule_item_title{
        font-size: 12px;
        color: #CACACA;
        // height: 25%;
      }
      .schedule_item_content{
        font-size: 25px;
        text-align: right;

        // height: 50%;
        font-family: DINPro-BlackItalic;
      }

      .schedule_item_bottom{
        font-size: 10px;
        color: #5483D2;
        // height: 25%;
      }
    }

    }


    
  }


  .classroom_box{
    margin-top: 14px;
    border-radius: 15px;
    // padding: 10px;
     .schedule_list{
      // display: flex;
      // justify-content: space-between;
        width: 100%;
        height: calc(100% - 40px);
        overflow-x: auto; /* 启用水平滚动 */
        scrollbar-width: thin; /* 可选：优化滚动条样式 */
      /* 隐藏滚动条但保留功能 (可选) */
    &::-webkit-scrollbar {
      display: none;
    }
    
    .schedule_item {
      display: flex;
      height: 100px;
      width: calc(100% - 4vw);
      background-color: #fff;
      // margin: 10px 0;
      margin-bottom: 14px;
      // min-width: 150px; /* 使用 min-width 而非固定宽度，确保有足够空间显示内容 */
      // margin-right: 1%; /* 添加间距 */
      flex-shrink: 0; /* 防止子项被压缩 */
      background-color: #fff;
      border-radius: 15px;
      padding: 2vw;

      // height: 150px;
      // width: calc(50% - 4vw);
      // flex-shrink: 0; /* 防止子项被压缩 */
      // background-color: #fff;
      // border-radius: 15px;
      // padding: 2vw;
      // text-align: center;

      .schedule_item_title{
        font-size: 16px;
        color: #000000;
        font-weight: 500;
        width: 100%;
      }
      .schedule_item_content{
        font-size: 12px;
        color: #a3a1a1;
        margin-top: 30px;
        // height: 50%;
        font-family: DINPro-BlackItalic;
      }
      .schedule_item_bottom{
        display: flex;
        justify-content: space-between;
      
        margin-top: 10px;
           .schedule_item_bottom_left{
            display: flex;
            align-content: center;
            align-items: center;
            font-size: 12px;
            color: #0074D2;
        
           }
            .schedule_item_btn{
            background-color: #E7F5FE;
            width: 50px;
            height: 22px;
            line-height: 22px;
            text-align: center;
            border-radius: 20px;
            font-size: 12px;
            color: #0074D2;
          }
  
      }
  
    }

    }

  }
.menu{
  font-size: 13px;
  margin-top: 15px;
  .menu_down{
    text-align: center;
    margin: 10px;


 .center{
        height: 118px;
        line-height: 118px;
        text-align: center;
        position: relative;
        // background-color: #fff;
        // border-radius:10px;
        margin-top: 16px;
        box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);
        object-fit: cover;
        .center_text{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            font-size: 20px;
            font-weight: 700;
            color: #458ff1b9;
        }
        .center_value{
            color: #bbb;
        }
    }


  }
 .menu_row{
    text-align: center;
   display: flex;
   flex-wrap: wrap;
   align-items: center;
   justify-items: center;
   text-align: center;
   
   .menu_li{
    margin: 10px auto;
    background-color: #fff;
    border-radius: 10px;
    padding: 10px;
   }

 } 

}
 ::v-deep .van-grid-item__content{
    padding: 16px 6px!important;
  background: #eeeeee;
  }


.userinfo {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #aaa;
}
.myHeader{
  margin: auto;
  padding-top: 40px;
  width: 90%;
}

.appeal-list {
  font-size: 14px;
  display: flex;
  flex-direction: column;

  &-title{
   display: flex;
   justify-content: space-between;

  }
  &-warp {
    // flex: 1;
    // padding: 0px 10px;
    background-color: #fff;
    // padding-top: 10px;
    padding: 4vw;
    border-radius: 15px;
    // margin: 10px;
  .mileagebox{
      display: flex;
      align-items: baseline;
      margin-top: 10px;
    }
    .mileageStyle{
      width: 100%;
      font-size: 28px;
      font-family: DINPro-Bold;
      overflow: hidden;
      white-space: nowrap;      /* 不换行 */
      // font-weight: 700;
      
      color: #2e8bd3;

    }
    .getIntegralBox{
      position: absolute;
      top: 8px;
      display: flex;
      flex-direction: column;
      // justify-content: space-around;
      justify-content: space-evenly;
      
      width: 14vw;
      height: 18vw;
      border-radius: 15px;
      text-align: center;
      font-size: 12px;
      color: #fff;
 background-image: -moz-linear-gradient( 90deg, rgb(1,94,234) 0%, rgb(0,192,250) 100%);
  background-image: -webkit-linear-gradient( 90deg, rgb(1,94,234) 0%, rgb(0,192,250) 100%);
  background-image: -ms-linear-gradient( 90deg, rgb(1,94,234) 0%, rgb(0,192,250) 100%);
  box-shadow: inset 0px -4px 6px 0px rgba(0, 85, 207, 0.73),inset 0.052px 3px 5px 0px rgba(221, 247, 255, 0.78);

    }
     .getIntegralBoxV2{
      position: absolute;
      top: 8px;
      display: flex;
      flex-direction: column;
      // justify-content: space-around;
      justify-content: space-evenly;
      
      width: 14vw;
      height: 18vw;
      border-radius: 15px;
      text-align: center;
      font-size: 12px;
  color: rgb(46, 139, 211);

  background-color: rgb(225, 238, 247);
  box-shadow: inset 0.035px 2px 4px 0px rgba(193, 212, 222, 0.69);
    }
    .item {
      margin-top: 15px;
   
  .item-li{
    display: flex;

    .item-li-left{
      // position: relative;
      // width: 20%;
      // text-align: center;
      // margin: auto;

      position: relative;
  width: 20%;
  text-align: center;
  margin: auto;
  min-height: 80px; /* 根据实际高度调整 */
    }
    .timeline-line {
      position: absolute;
      left: 50%;
      top: 65px;
      width: 1px;
      height: 70%;
      background: #e0e0e079;
      transform: translateX(-50%);
      z-index: 0;
    }
    .item-li-right{
      // background: linear-gradient(147deg, #DAFF8D 0%, #DAFF8D 100%);
      // background: #fff;
      // box-shadow: 0px 1px 6px 0px #eef1fc;
      border-radius: 10px;
      padding: 12px;
      width: 70%;
      display: flex;
      flex-direction: column;
      position: relative;
      .item-li-right-goal{
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 16px;
        font-weight: 600;
        // height: 100%;



        // font-family: DINPro-Regular;
      }
    }





    .item-li-righta{
      background-color: rgb(239, 250, 255);
      box-shadow: 0px 2px 3px 0px rgba(147, 189, 216, 0.42);
      border-radius: 15px;


      // background-image: url('../../assets/background/indexli.png');
      // background-size: 100% 100%;
      // background-repeat: no-repeat;
      // color: #fff;
    }
    .item-li-rightb{
      background-color: rgb(239, 250, 255);
      box-shadow: 0px 2px 3px 0px rgba(147, 189, 216, 0.42);
      border-radius: 15px;


      // background-image: url('../../assets/background/indexliv2.png');
      // background-size: 100% 100%;
      // background-repeat: no-repeat;
    }
  }


      .right {
          font-size: 16px;
          font-weight: 500;
        
          &.bg0 {
            // background: #ffecde;
            color: #ff5600;
          }
          &.bg1 {
            // background: #e4f2ff;
            color: #007ff0;
          }
          &.bg2 {
            // background: #e4f2ff;
            color: #007ff0;
          }
          &.bg3 {
            // background: #ffe9eb;
            color: #ff0000;
          }
        }
    }
  }
  .footer {
    display: flex;
    margin-bottom: 3%;
    margin-top: 5%;
    justify-content: space-around;
    /deep/.van-button {
        
      flex-basis: 80%;
    }
  }
}
</style>
